import { UiProvider } from "../context/Providers/UiProvider";

import { Navbar } from "./UI/Navbar";
import Header from "./container/Header";
import About from "./container/About";
import Work from "./container/Work";
import Skill from "./container/Skills";
// import Testimonial from "./container/Testimonial";
import Footer from "./container/Footer";

import "./../assets/scss/App.scss";

function App() {
  return (
    <div className="app dark-theme">
      <UiProvider>
        <Navbar />
        <Header />
        <About />
        <Work />
        <Skill />
        {/* <Testimonial /> */}
        <Footer />
      </UiProvider>
    </div>
  );
}

export default App;
